import { render, staticRenderFns } from "./cpt-core.vue?vue&type=template&id=f56fcdc8&scoped=true"
import script from "./cpt-core.vue?vue&type=script&lang=js"
export * from "./cpt-core.vue?vue&type=script&lang=js"
import style0 from "./cpt-core.vue?vue&type=style&index=0&id=f56fcdc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f56fcdc8",
  null
  
)

export default component.exports